<template>
    <div class="wpb__container page_content">
        <aside class="filters">
            <!-- <div class="mobile-filter__open filter__btn">

                <button @click="toggleScroll">
                    <span v-text="filterText">
                      </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>

                </button>

            </div> -->
            <div class="tickets-filter" :class="{visible: filterVisible}">

                <bhf-category-switcher :product-categories="productCategories"></bhf-category-switcher>

                <!-- <button @click="toggleScroll" class="mobile-filter__close filter-btn">{{ applyFilterText }}</button> -->

                <!-- ugly fix, to make the button visible -->
                <!--<div style="width: 100%; height: 70px;"></div>-->

            </div><!-- /.filter-section -->
        </aside><!-- /.aside -->

        <div>
                <h1 class="listing-title">{{ productCategory.title }}</h1>

                <bhf-listing ref="listing" :products="products" :isFetching="isFetching"></bhf-listing>
        </div>

    </div>
</template>
<script>
    import 'jquery-match-height';
    import Slick from 'vue-slick'
    import BhfListing from './bhf-filter-listing.vue'
    import BhfSelect from './bhf-filter-select.vue'
    import BhfCategorySwitcher from './bhf-category-switcher.vue'
    import BhfSpecialFilterSwitcher from './bhf-special-filter-switcher.vue'
    import BhfSpecialFilterSlides from './bhf-special-filter-slide.vue'
    import axios from 'axios';
    import helpers from '../../helpers';
    import throttle from 'lodash/throttle';

    $(window).on('load', function () {
        matchHeight();
    });

    $(window).on('resize', function () {
        throttle(matchHeight, 800);
    });

    function matchHeight(){
        $('.product-content').matchHeight({byRow: true});
        $('.post__content-inner h2').matchHeight({byRow: true});

    }

    export default{
        components: {
            Slick,
            BhfCategorySwitcher,
            'bhf-listing': BhfListing,
            'bhf-select': BhfSelect,
            'bhf-category-switcher': BhfCategorySwitcher,
            'bhf-special-filter-switcher': BhfSpecialFilterSwitcher,
            'bhf-special-filter-slide': BhfSpecialFilterSlides
        },
        props: {
            'title': {required: true},
            // 'filterText': {required: true},
            'productData': {required: true},
            'specialFilters': {required: true},
            'productCategories': {required: true},
            'productCategoryData': {required: true},
        },
        data: function(){
            return {
                helpers: helpers,
                loaded: false,
                filterVisible: false,
                isFetching: false,
                productCategory: {},
                newsletterButton: null,
                products: this.productData,
                activeSpecialFilter: '',
            }
        },
        mounted: function(){
            this.products = this.productData;
            this.productCategory = this.productCategoryData;
            this.loaded = true;
            this.newsletterButton = document.getElementsByClassName('newsletter-action')[0];
        },
        watch: {
            '$route.params': function(params) {
                if(params.productSlug) {
                    this.fetchNewProducts(params.productSlug)
                }
            },
            'filteredProducts': function(){
                // this.$refs.listing.reInit();
            },
            'activeSpecialFilter': function(){
                this.reInitSponsorSlider();
            },
            'filterVisible': function(visible){
                (visible) ? this.newsletterButton.style.display = 'none' : this.newsletterButton.style.display = 'block';
            }
        },
        methods: {
            toggleScroll: function(){
                this.filterVisible = !this.filterVisible
                if(this.filterVisible) {
                    document.body.classList.add('overflow-hidden')
                }else{
                    document.body.classList.remove('overflow-hidden')
                }
            },
            fetchNewProducts: function(slug){
                let endpoint = '/api/v1/?locale=' + helpers.getLocale();

                if(slug !== undefined){
                    endpoint = '/api/v1/' + slug + '?locale=' + helpers.getLocale();
                }

                let _this = this;
                _this.isFetching = true;
                axios.get(endpoint)
                    .then(function (response) {

                        // Set new listing state\
                        _this.productCategory = response.data.activeProductCategory;
                        _this.products = response.data.products;

                        //jquery plugin to match the heights...
                        setTimeout(function(){
                            matchHeight();
                        }, 300);

                        _this.isFetching = false;
                    })
                    .catch(function (error) {
                        _this.isFetching = false
                    })

            },

            reInitSponsorSlider: function(){
                this.$nextTick(() => {
                    this.$refs.sponsor.reSlick();
                });
            },
        },
        computed: {
            filteredProducts: function(){
                return this.products;
            },

            filterText(){
                if(helpers.getLocale() === 'nl') {
                    return 'FILTEREN';
                }
                return 'FILTER';
            },

            applyFilterText(){
                if(helpers.getLocale() === 'nl') {
                    return 'FILTER TOEPASSEN';
                }
                return 'APPLY FILTER';
            },
        }
    }
</script>

<style lang="scss" scoped>


    @media only screen and (min-width: 993px) {
        .filters {
            margin-top: 108px;
        }
    }

    .listing-title{
        width: calc(100% - 270px);
        padding-left: 0px;
        margin-top: 0;
        margin-bottom: 18px;
        float: left;
    }

    @media only screen and (max-width: 767px) {
        .listing-title {
            width: 100%;
            float: none;
            padding-left: 0;
        }
    }

    .sponsor-banner{
        height: auto;
        margin-bottom: 40px;
        margin-right: -15px;
        width: calc(100% - 270px) !important;
        float: right;


        @media screen and(max-width: 992px) {
            width: calc(100% + 30px) !important;
            margin-right: -15px;
            margin-left: -15px;
        }


        .slick-slide{
            img{
                max-height: 331px;
                height: 331px;

                @media screen and(max-width: 992px) {
                    height: auto;
                }
            }
        }

        .slick-list{
            /*padding-left: 31px;*/
        }

        .slick-dots{
            list-style: none;
            padding: 0;
            margin: 0;
            position: absolute;
            bottom: 0;
            width: 100%;
            text-align: center;

            li{
                width: 4px;
                height: 4px;
                display: inline-block;
                border-radius: 50%;
                background: #ffffff;
                opacity: .5;
                margin: 0 4px;
                position: relative;
                vertical-align: bottom;
                cursor: pointer;

                box-shadow: 0 0 0 1.4px black;

                &.slick-active{
                    opacity: 1;
                    background: #000;
                }

                button{
                    opacity: 0;
                    position: absolute;
                    top: -4px;
                    left: -4px;
                    cursor: pointer;
                    width: 14px;
                    height: 14px;
                    padding: 0;
                }
            }
        }

        .slick-arrow{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            z-index: 1;
            border: 0;
            font-size: 0;
            line-height: 0;
            -webkit-transition: all 0.3s ease-in-out;
            -webkit-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
            width: 8px;
            height: 13px;
        }

        .slick-prev{
            left: 50px;
            background: url(/images/left_arrow.svg) no-repeat center center;
        }
        .slick-next{
            right: 50px;
            background: url(/images/right_arrow.svg) no-repeat center center;
        }

    }

    .sponsor-banner {
        padding: 15px;
        margin-bottom: 20px;
        position: relative;
        // background-image: url(/site/img/artis.jpg);
        @media only screen and (max-width: 475px) {
            padidng-left:0;
        }
        &__image {
            width:100%;
            @media only screen and (max-width: 500px) {
                min-height:180px;
            }
        }
        &__cta {
            position: absolute;
            top: 0;
            bottom: 0;
            padding: 20px;
            width: 100%;
            h2 {
                color: white;
                line-height: 1.2em;
                text-transform: uppercase;
                @media only screen and (max-width: 620px) {
                    font-size: 20px;
                }
            }
            a {
                float: right;
                background: white;
                color:black;
                text-transform: uppercase;
                right: 45px;
                bottom: 30px;
                position: absolute;
                text-decoration: none;
                padding: 5px 8px;
            }
        }
    }

    .filter-btn{
        width: 100%;
    }

    .filter__btn{
        border: none;
        max-width: 288px;
        margin-left: -10px;
        button{
            padding: 0 10px;
            border: 2px solid #000000;
            background: none;
            font-size: 14px;
            svg{
                margin-bottom: 4px;
            }
        }
    }
    .filter--pgh{
        margin-top: 15px;
    }



    @media screen and(max-width: 374px){
        .filters h1{
            margin-left: -15px;
        }
        .filter__btn{
            margin-left: -24px;
            margin-right: -20px;
            a{
                font-size: 13px;
            }
        }
    }

    @media screen and(min-width: 375px) and (max-width: 413px) {
        .filter__btn {
            margin-left: -24px;
        }
        .filters h1 {
            margin-left: -13px;
        }
    }

    @media screen and (max-width: 767px){
        .filter__btn {
            padding: 0 0 0 10px;
        }
    }

    .icon{
        background: url(/images/arrow.svg?0eb75b8…) no-repeat 100%;
        width: 22px;
        height: 33px;
        display: inline-block;
        float: right;
    }

    @media screen and (max-width: 767px){
        .listing-title {
            display: none;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/bhf-filter/bhf-filter-root.vue